<!-- Tabs de tubos -->
<div class="row" *ngIf="tubos.length > 0" style="margin-bottom: 10px;">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <mat-tab-group [selectedIndex]="selectedTabIndex"
                        (selectedTabChange)="onTuboChange($event.index)"
                        animationDuration="200ms">
            <mat-tab *ngFor="let tubo of tubos" [label]="tubo.business_name">
            </mat-tab>
        </mat-tab-group>
    </div>
</div>

<!-- Loading -->
<div class="row" *ngIf="loading">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__fadeIn container-loading">
        <div class="img-loading">
            <img src="../../assets/img/loading.png" class="img-loading1">
        </div>
        <div style="margin-top: 20px;">
            <mat-label class="label-loading">
                <div>La información está siendo procesada.</div>
                <div>Esto no tomará mucho tiempo.</div>
            </mat-label>
        </div>
    </div>
</div>

<!-- Contenido -->
<div class="row" *ngIf="!loading && selectedCompanyId">
    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 col-top">
        <app-crear-cuenta-bancaria [load_data]="false" [id_company]="selectedCompanyId"
            (funciones)="procesaPropagar($event)">
        </app-crear-cuenta-bancaria>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 col-top">
        <ctas [actualizar]="actualizar" [company_id]="selectedCompanyId"></ctas>
    </div>
</div>
